<app-menu [hasChanges]="loadMenu" title="Tablero de control"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="flex flex-wrap">
    <!-- Section fechas -->
    <div class="w-full md:w-4 p-2">
        <div class="p-fluid pl-2 text-center">
            <label for="range">Seleccione el rango de fechas</label>
            <div class="p-field w-full flex align-items-center gap-2">
                <div class="p-field w-full">
                    <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" inputId="range"
                        size="small" (onSelect)="hideDate()" dateFormat="yy-mm-dd" showIcon="true"></p-datepicker>
                </div>
                <div class="mx-auto w-min pt-1">
                    <button pButton icon="pi pi-search" class="w-min p-button p-button-success p-2"
                        (click)="getInfoVentas(false)"></button>
                </div>
            </div>
        </div>
        <h4 class="uppercase">Total venta</h4>
        <div class="flex flex-wrap justify-content-between">
            <div class="w-6 p-1 text-center">
                <div class="m-1 border-2 bg-green-500 border-white text-white border-round">
                    <p class="p-1">Venta total<br>{{valorGeneral | currency}}</p>
                </div>
            </div>
            <div class="w-6 p-1 text-center">
                <div class="m-1 border-2 bg-primary border-white text-white border-round">
                    <p class="p-1">Meta total<br>{{metaGeneral | currency}}</p>
                </div>
            </div>
            <div class="w-full bg-simescco m-2 text-center border-300 border-round ">
                <p class="p-1">Alcance: {{(metaGeneral ==0?0:(valorGeneral/metaGeneral)) | percent:'2.1'}}</p>
            </div>
        </div>
    </div>
    <!-- Sección de ventas -->
    <div class="w-full md:w-4 p-2 flex align-items-center">
        <div class="w-full m-2">
            <div class="w-full m-1 text-center"> <label>Venta / Meta</label></div>
            <p-card class="border-round">
                <div class="flex justify-content-center">
                    <apx-chart [colors]="chartOptions.fill.colors" [series]="chartOptions.series"
                        [chart]="chartOptions.chart" [labels]="chartOptions.labels" [title]="chartOptions.title"
                        [yaxis]="chartOptions.yaxis" #chart></apx-chart>
                </div>
            </p-card>
        </div>
    </div>
    <!-- Sección de Tipo de Pago -->
    <div class="w-full md:w-4 p-2 flex align-items-center">
        <div class="w-full m-1 text-center"> <label>Discriminación por tipo de pago</label>
            <p-card class="border-round">
                <div class="flex justify-content-center">
                    <apx-chart [series]="chartOptions1.series" [chart]="chartOptions1.chart"
                        [labels]="chartOptions1.labels" [title]="chartOptions1.title" #chart
                        [yaxis]="chartOptions1.yaxis"></apx-chart>
                </div>
            </p-card>
        </div>
    </div>
    <!-- Sección por canal de ventas -->
    <div class="w-full md:w-4 p-2 flex align-items-center">
        <div class="w-full  p-2 flex align-items-center">
            <div class="w-full m-1 text-center"> <label>Discriminación por canal de venta</label>
                <p-card class="border-round">
                    <div class="flex justify-content-center">
                        <apx-chart [series]="chartOptions4.series" [chart]="chartOptions4.chart"
                            [labels]="chartOptions4.labels" [title]="chartOptions4.title" #chart
                            [yaxis]="chartOptions4.yaxis"></apx-chart>
                    </div>
                </p-card>
            </div>
        </div>
    </div>
    <!-- Sección de Ventas por tienda y vendedor -->
    <div class="w-full md:w-4 p-2">
        <div class="w-full max-h-screen overflow-scroll">
            <p-select [options]="optionsOrder" [(ngModel)]="selectedOrderBy" optionLabel="name" size="small"
                placeholder="Tipos de ordenamiento" (onChange)="setOrderStore()"></p-select>
            <div class="text-center"><label>Discriminacion por tienda</label></div>

            <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [legend]="chartOptions2.legend"
                [dataLabels]="chartOptions2.dataLabels" [colors]="chartOptions2.colors" [yaxis]="chartOptions2.yaxis"
                [plotOptions]="chartOptions2.plotOptions" #chart2></apx-chart>
        </div>
    </div>
    <!-- Sección de Ventas por tienda y vendedor -->
    <div class="w-full md:w-4 p-2">
        <div class="w-full max-h-screen overflow-scroll">
            <div class="pt-3">
                <div class="text-center"><label>Discriminacion por vendedor</label></div>
                <apx-chart [series]="chartOptions3?.series" [chart]="chartOptions3?.chart"
                    [legend]="chartOptions3?.legend" [dataLabels]="chartOptions3?.dataLabels"
                    [colors]="chartOptions3?.colors" [yaxis]="chartOptions3?.yaxis"
                    [plotOptions]="chartOptions3?.plotOptions" #chart3></apx-chart>

            </div>
        </div>
    </div>

</div>

<hr>
<div class="flex flex-wrap">


    <div class="w-full md:w-6">
        <div class="overflow-scroll max-h-screen h-30rem text-center">
            <div class=" flex flex-wrap text-center sticky top-0 bg-white border-1 border-round-top border-gray-50 p-2">
                <div class="w-full">
                    <p-select [options]="optionsProduct" [(ngModel)]="selectedOptionProduct" optionLabel="name"
                        size="small" (onChange)="loadItems()"></p-select>
                </div>
                <div class="w-4">Producto</div>
                <div class="w-4">Cantidad</div>
                <div class="w-4">Total</div>
            </div>
            <div class="flex flex-wrap text-xs text-center border-1 border-gray-50 p-2" *ngFor="let row of lsProduct">
                <div class="w-4 text-">{{row.producto.descripcionCorta.toUpperCase()}} -
                    {{row.producto.codBarras}}
                </div>
                <div class="w-4">{{row.cantidad | number}}</div>
                <div class="w-4">{{(row.subtotal + row.impuesto) | currency}}</div>
            </div>
        </div>
    </div>
</div>